<template>
  <div>
    <div v-if="!getting">
      <!-- new commnet -->
      <div class="mb-4" v-if="canComment">
        <button
          class="sr__comment-btn"
          v-show="!newCommentOpening"
          @click="toNewComment"
        >
          <span>{{addCommentLabel}}</span>
        </button>

        <div class="sr__comment-box" v-show="newCommentOpening">
          <textarea
            ref="commentRef"
            @input="autoTextareaHeight($event.target)"
            placeholder="請輸入..."
            v-model="newCommentContent"
          ></textarea>

          <div class="d-flex justify-content-end">
            <button
              class="sr__comment-action mr-1"
              @click="newCommentOpening=!newCommentOpening"
              :disabled="createCommenting"
            >取消</button>

            <button
              class="sr__comment-action sr__comment-action--submit"
              @click="createComment"
              :disabled="createCommenting"
            >{{ `送出${this.createCommenting ? '中...' : ''}` }}</button>
          </div>
        </div>
      </div>

      <!-- comments -->
      <div class="mb-2" v-if="comments.length > 0">
        <div
          class="sr-cmt__cmt"
          :class="{'sr-cmt__cmt--checked': cmt.checked}"
          v-for="(cmt, index) in comments"
          :key="`${cmt.id}-${index}`"
        >
          <div class="d-flex">
            <!-- avatar -->
            <div class="d-flex align-items-start">
              <div class="sr__avater">
                <img :src="cmt.avatar_url">
              </div>
            </div>

            <div class="w-100">
              <div class="sr-cmt__meta">
                <!-- meta -->
                <div class="font-weight-bold">{{ cmt.name }}</div>
                <div class="px-1 sr-cmt__at">•</div>
                <div class="mr-2">{{ cmt.updated_at }}</div>

                <!-- destroy icon -->
                <div
                  @click="destroyComment(cmt)"
                  v-if="!cmt.editing && !cmt.deleted && !cmt.checked && canComment"
                >
                  <b-icon icon="trash2"></b-icon>
                </div>
              </div>

              <!-- edit, comment, check -->
              <div v-show="!cmt.editing && !cmt.deleted">
                <div class="sr-cmt__content mb-1">
                  {{ cmt.content }}
                </div>

                <div v-if="!cmt.checked && !cmt.replying" class="d-flex align-items-center">
                  <!-- edit -->
                  <div v-if="canComment" class="d-flex align-items-center mr-3" @click="editComment(cmt, index)">
                    <b-icon class="mr-1" icon="pencil-square"></b-icon>
                    <span class="f-14">修改</span>
                  </div>

                  <!-- reply -->
                  <div v-if="canReply" class="d-flex align-items-center mr-3" @click="toReplyNewComment(cmt, index)">
                    <b-icon class="mr-1" style="margin-bottom: .125rem;" icon="chat" @click="reply"></b-icon>
                    <span class="f-14">回覆</span>
                  </div>

                  <!-- check -->
                  <div v-if="canComment" class="d-flex align-items-center" @click="checkComment(cmt, index)">
                    <b-icon class="mr-1" style="color: #1f931f;" icon="check-square"></b-icon>
                    <span class="f-14">通過</span>
                  </div>

                </div>
              </div>

              <!-- edit comment -->
              <div class="sr__comment-box" v-show="cmt.editing">
                <textarea
                  @input="autoTextareaHeight($event.target)"
                  placeholder="請修改評論..."
                  v-model="cmt.content"
                  ref="commentItems"
                ></textarea>
                <div class="d-flex justify-content-end">
                  <button
                    class="sr__comment-action mr-1"
                    :disabled="cmt.sending"
                    @click="cancelEditComment(cmt)"
                  >取消</button>

                  <button
                    class="sr__comment-action sr__comment-action--submit"
                    :disabled="cmt.sending"
                    @click="updateComment(cmt)"
                  >{{ `送出${cmt.sending ? '中...' : ''}` }}</button>
                </div>
              </div>

              <!-- reply -->
              <div class="sr__comment-box" v-show="cmt.replying">
                <textarea
                  @input="autoTextareaHeight($event.target)"
                  placeholder="請回覆審核評論..."
                  v-model="cmt.replyContent"
                  ref="replyCommentItems"
                ></textarea>

                <div class="d-flex justify-content-end">
                  <button
                    class="sr__comment-action mr-1"
                    :disabled="cmt.sending"
                    @click="cmt.replying=!cmt.replying"
                  >取消</button>

                  <button
                    class="sr__comment-action sr__comment-action--submit"
                    :disabled="cmt.sending"
                    @click="reply(cmt)"
                  >{{ `送出${cmt.sending ? '中...' : ''}` }}</button>
                </div>
              </div>

              <!-- reply comments -->
              <div class="mt-2">
                <div
                  v-for="replyCmt in cmt.reply_comments"
                  :key="`${cmt.id}-reply-${replyCmt.id}`"
                >
                  <Comment
                    :orgCmt="replyCmt"
                    :recordId="recordId"
                    :lineId="lineId"
                    :replyId="replyCmt.id"
                    :disabled="cmt.checked"
                  ></Comment>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <span class="lds-dual-ring" v-if="getting"></span>
  </div>
</template>

<script>
import Vue from 'vue'
import Comment from './Comment.vue'

export default {
  name: 'ReviewComment',
  props: {
    canComment: Boolean,
    canReply: Boolean,
    addCommentLabel: String,
    currentPageIden: String
  },
  data () {
    return {
      lineId: '',
      recordId: '',
      newCommentContent: '',
      newCommentOpening: false,
      createCommenting: false,
      getting: false,
      comments: []
    }
  },
  watch: {
    async currentReviewItem () {
      this.comments = this.currentReviewItem.review_comments
      this.comments.forEach((e) => {
        Vue.set(e, 'editing', false)
        Vue.set(e, 'deleted', false)
        Vue.set(e, 'sending', false)
        Vue.set(e, 'replying', false)
        Vue.set(e, 'replyContent', '')
        Vue.set(e, 'rawContent', e.content)
      })
    }
  },
  created () {
    this.lineId = this.$store.state.userId
    this.recordId = this.$route.params.id
  },
  computed: {
    currentReviewItem () {
      return this.$store.state.reviewItem
    }
  },
  methods: {
    apiUrl (action) {
      return `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/${this.recordId}/${this.apiAction(action)}`
    },
    replyApiUrl (action) {
      return `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/${this.recordId}/${this.replyApiAction(action)}`
    },
    apiAction (action) {
      var base = 'review_comment'
      if (action === 'get') {
        base = `${base}s`
      }

      return `${action}_${base}`
    },
    replyApiAction (action) {
      var base = 'reply_comment'
      return `${action}_${base}`
    },
    async reply (cmt) {
      cmt.replying = true

      const options = {
        comment: {
          service_record_review_comment_id: cmt.id,
          content: cmt.replyContent
        }
      }

      var r = false
      try {
        const resp = await this.$api.post(this.replyApiUrl('add'), options)
        cmt.reply_comments.unshift(resp.comment)

        cmt.replyContent = ''
        r = true
      } catch (e) {
        console.error(e)
      }

      cmt.replying = false
      return r
    },
    async createComment () {
      this.createCommenting = true
      const options = {
        page_iden: this.currentPageIden,
        comment: {
          uuid: this.currentReviewItem.uuid,
          content: this.newCommentContent
        }
      }

      var r = false
      try {
        const resp = await this.$api.post(this.apiUrl('add'), options)
        this.comments.unshift(resp.comment)
        Vue.set(this.comments[0], 'editing', false)
        Vue.set(this.comments[0], 'deleted', false)
        Vue.set(this.comments[0], 'sending', false)
        Vue.set(this.comments[0], 'replying', false)
        Vue.set(this.comments[0], 'rawContent', this.comments[0].content)

        this.newCommentContent = ''
        this.newCommentOpening = false
        r = true

        this.$emit('reviewPageMenuItems')
      } catch (e) {
        console.error(e)
      }

      this.createCommenting = false
      return r
    },
    editComment (cmt, index) {
      cmt.editing = !cmt.editing
      this.autoTextareaHeight(this.$refs.commentItems[index])
    },
    async checkComment (comment) {
      var yes = confirm('確定檢查通過?')
      if (!yes) {
        return
      }

      comment.sending = true
      const options = {
        comment_id: comment.id,
        comment: {
          checked: true
        }
      }

      var r = false
      try {
        await this.$api.post(this.apiUrl('check'), options)
        comment.checked = true
        r = true
        this.$emit('reviewPageMenuItems')
      } catch (e) {
        console.error(e)
      }

      comment.sending = false
      return r
    },
    cancelEditComment (comment) {
      var yes = confirm('確定取消?')
      if (yes) {
        comment.content = comment.rawContent
        comment.editing = false
      }
    },
    async updateComment (comment) {
      comment.sending = true
      const options = {
        comment_id: comment.id,
        comment: {
          page_iden: this.pageIden,
          content: comment.content
        }
      }

      var r = false
      try {
        const resp = await this.$api.post(this.apiUrl('update'), options)
        var updatedComment = resp.comment
        comment.updated_at = updatedComment.updated_at
        comment.content = updatedComment.content
        comment.rawContent = updatedComment.content

        comment.editing = false
        r = true
      } catch (e) {
        console.error(e)
      }

      comment.sending = false
      return r
    },
    async destroyComment (comment) {
      var yes = confirm('確定刪除評論?')
      if (!yes) {
        return
      }
      comment.content = ''
      comment.deleted = true
      comment.checked = true
      comment.name = '評論刪除中...'

      const options = {
        comment_id: comment.id
      }

      var r = false
      try {
        await this.$api.post(this.apiUrl('destroy'), options)
        comment.name = '評論已刪除'

        r = true
        this.$emit('reviewPageMenuItems')
      } catch (e) {
        comment.name = '刪除失敗'
        console.error(e)
      }

      return r
    },
    autoTextareaHeight (target) {
      this.$nextTick(() => {
        target.style.height = target.scrollHeight + 'px'
      })
    },
    toNewComment () {
      this.newCommentOpening = !this.newCommentOpening
      this.$nextTick(() => {
        this.$refs.commentRef.focus()
      })
    },
    toReplyNewComment (cmt, index) {
      cmt.replying = true
      this.autoTextareaHeight(this.$refs.replyCommentItems[index])
    }
  },
  components: {
    Comment
  }
}
</script>
